import SelectListModel from '../../models/app/SelectListModel';

const GenderList = [
  new SelectListModel('2', 'Female'),
  new SelectListModel('1', 'Male'),
  new SelectListModel('0', 'Prefer Not Say'),
] as SelectListModel[];

export default GenderList;
